module.exports = __webpack_public_path__ + "img/buy-car1024x576.549e7819.png";